import React, { Component } from "react";
import { Flex } from "../../styles/GlobalStyle.js";
import "react-responsive-modal/styles.css";
import {
  TitleName,
  TitleOrder,
  Detail,
  Container,
  Subtotal,
  Total,
  ProductOption,
  Status,
  StatusValue,
  Notes,
} from "./style/SuccessStyle.js";
import LocalGroceryStoreIcon from "@material-ui/icons/LocalGroceryStore";
import { Avatar } from "@material-ui/core";
import Property from "../../model/property";
import { get, isEmpty, isUndefined } from "lodash";
import moment from "moment";
import { withTranslation } from "react-i18next";
import ErrorModal from "../../components/modal/ErrorModal";
import Link from "../../components/Link";

class SuccessOrder extends Component {
  state = {
    order: {},
    errorModalStatus: false,
    preset: {},
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const { match } = this.props;
    if (match.url === "/success") {
      window.history.pushState(null, document.title, window.location.href);
      window.addEventListener("popstate", () => {
        window.history.pushState(null, document.title, window.location.href);
        this.setState({ errorModalStatus: true });
      });
    }
    const orderSuccess = Property.getOrderSuccess();
    this.setState({
      order: orderSuccess,
    });
    Property.clearOrderSuccess();
    Property.clearCartItem();
  }

  componentDidUpdate() {
    if (isEmpty(this.state.preset) && !isUndefined(Property.getPreset())) {
      const presets = Property.getPreset();
      if (presets && !isEmpty(presets.app_webstore_favicon_url)) {
        const favicon = document.getElementById("favicon");
        if (favicon) favicon.href = presets.app_webstore_favicon_url;
        const appleFavicon = document.getElementById("apple-favicon");
        if (appleFavicon) appleFavicon.href = presets.app_webstore_favicon_url;
      }
      this.setState({ preset: presets });
    }
  }

  render() {
    const { order, preset } = this.state;
    const products = get(order, "products", []);
    const extraCharges = get(order, "price_detail.extra_charges", []);
    const lastExtraCharges = get(order, "price_detail.last_extra_charges", []);
    const createAt = get(order, "created_at");
    const notes = get(order, "notes", "");
    const currencyCode = Property.getCurrencyCode();
    return (
      <Container
        className={"sectionContent"}
        id="list-container">
        {this.state.errorModalStatus ? (
          <ErrorModal
            stateModal={this.state.errorModalStatus}
            openCloseModal={(modalStatus) =>
              this.setState({ errorModalStatus: modalStatus })
            }
            textTitle={this.props.t("WARNING")}
            btnErrorText={this.props.t("OK")}
            childText={this.props.t("TRANSACTION_COMPLETE")}
          />
        ) : null}
        <Flex
          container
          flex={1}
          padding="15px"
          alignItems="center"
          justifyContent="space-between">
          <TitleOrder
            className={"finishTitle"}
            app_home_color_primary={preset.app_home_color_primary}>
            <LocalGroceryStoreIcon
              fontSize="large"
              style={{ verticalAlign: "text-top" }}
            />
            {this.props.t("HOTEL_STORE")}
          </TitleOrder>
          <TitleOrder
            className={"finishTitle"}
            app_home_color_primary={preset.app_home_color_primary}>
            {Intl.NumberFormat(currencyCode, {
              style: "currency",
              currency: currencyCode,
              currencyDisplay: "code",
            }).format(get(order, "price_detail.total", 0))}
          </TitleOrder>
        </Flex>
        <hr />
        <Flex
          container
          flex={1}
          margin="15px"
          alignItems="center"
          justifyContent="space-between">
          <Subtotal
            fontSize="12px"
            color="gray">
            {this.props.t("ASSIGNED_TO")}
          </Subtotal>
        </Flex>
        <Flex
          container
          flex={1}
          margin="15px"
          alignItems="center"
          justifyContent="space-between">
          <Flex
            container
            alignItems="center">
            <Avatar src={get(order, "staff_detail.avatar")} />
            <Flex margin="0 0 0 5px">
              <TitleName>{get(order, "staff_detail.full_name")}</TitleName>
              <Detail>{get(order, "staff_detail.role")}</Detail>
            </Flex>
          </Flex>
          <Flex>
            <Status>{this.props.t("STATUS")}</Status>
            <StatusValue app_home_color_primary={preset.app_home_color_primary}>
              {get(order, "status_in_text") || get(order, "status")}
            </StatusValue>
          </Flex>
        </Flex>
        <Flex
          container
          flex={1}
          margin="15px"
          alignItems="center"
          justifyContent="space-between">
          <Detail>{`${this.props.t("CREATED")}: ${moment(createAt).format(
            "h:mma L"
          )}`}</Detail>
        </Flex>
        <hr />
        {products.map((product, i) => (
          <Flex
            container
            flex={1}
            margin="15px"
            justifyContent="space-between"
            key={i}>
            <Flex
              container
              flex={1}>
              <Detail>{product.quantity}x</Detail>
              <Flex margin="0 0 0 5px">
                <div>{product.title}</div>
                <ProductOption>{product.options}</ProductOption>
              </Flex>
            </Flex>
            <div>
              {Intl.NumberFormat(currencyCode, {
                style: "currency",
                currency: currencyCode,
                currencyDisplay: "code",
              }).format(product.total)}
            </div>
          </Flex>
        ))}
        <hr />
        <Flex
          margin="15px"
          alignItems="center"
          justifyContent="space-between">
          <Flex
            container
            justifyContent="space-between"
            margin="2px 0">
            <Subtotal>{this.props.t("SUBTOTAL")}</Subtotal>
            <Subtotal>
              {Intl.NumberFormat(currencyCode, {
                style: "currency",
                currency: currencyCode,
                currencyDisplay: "code",
              }).format(get(order, "price_detail.subtotal", 0))}
            </Subtotal>
          </Flex>
          {extraCharges &&
            extraCharges.map((extraCharge, i) => (
              <Flex
                container
                justifyContent="space-between"
                margin="2px 0"
                key={i}>
                <Subtotal>
                  {extraCharge.title}
                  {extraCharge.type === "percent"
                    ? ` (${extraCharge.value}%)`
                    : ``}
                </Subtotal>
                <Subtotal>
                  {Intl.NumberFormat(currencyCode, {
                    style: "currency",
                    currency: currencyCode,
                    currencyDisplay: "code",
                  }).format(extraCharge.amount)}
                </Subtotal>
              </Flex>
            ))}
          {lastExtraCharges &&
            lastExtraCharges.map((lastExtraCharge, i) => (
              <Flex
                container
                justifyContent="space-between"
                margin="2px 0"
                key={i}>
                <Subtotal>
                  {lastExtraCharge.title}
                  {lastExtraCharge.type === "percent"
                    ? ` (${lastExtraCharge.value}%)`
                    : ``}
                </Subtotal>
                <Subtotal>
                  {Intl.NumberFormat(currencyCode, {
                    style: "currency",
                    currency: currencyCode,
                    currencyDisplay: "code",
                  }).format(lastExtraCharge.amount)}
                </Subtotal>
              </Flex>
            ))}
        </Flex>
        <hr />
        <Flex
          container
          flex={1}
          margin="15px"
          alignItems="center"
          justifyContent="space-between">
          <Total>{this.props.t("TOTAL")}</Total>
          <Total>
            {Intl.NumberFormat(currencyCode, {
              style: "currency",
              currency: currencyCode,
              currencyDisplay: "code",
            }).format(get(order, "price_detail.total", 0))}
          </Total>
        </Flex>
        <Flex
          container
          flex={1}
          margin="15px"
          alignItems="center"
          justifyContent="center">
          <Notes>{notes}</Notes>
        </Flex>
        <Flex
          container
          flex={1}
          margin="15px"
          alignItems="center"
          justifyContent="center">
          {isEmpty(Property.getStore().call_to_action_link) ? null : (
            <Link
              fontSize={"20px"}
              disabled={this.state.edit}
              href={Property.getStore().call_to_action_link}
              label={Property.getStore().call_to_action_text}
              backgroundColor={preset.app_home_color_primary}
              borderRadius={"30px"}
              color={preset.text_color}></Link>
          )}
        </Flex>
      </Container>
    );
  }
}

export default withTranslation()(SuccessOrder);
